import {
  buildCommissionSheetTableRowsFromConfig,
  fromCommissionTableRows,
  toCommissionTableRows
} from './inventoryCommissionHelpers';

const getSalesLocationId = salesLocation =>
  (salesLocation?._id || salesLocation)?.toString?.() || salesLocation?.toString?.() || '';

const findPnlConfigEntry = (appChoiceValues = [], unitLocationId, category) => {
  const locationId = unitLocationId?.toString?.() || unitLocationId || '';
  return appChoiceValues.find(
    entry => getSalesLocationId(entry.salesLocation) === locationId && entry.category === category
  );
};

export const getPnlConfigForInventory = (appChoices = [], unitLocationId, numberOfSections) => {
  const category = Number(numberOfSections) !== 1 ? 'Multi Wide' : 'Single Wide';
  const pnlOptionsChoice = appChoices.find(choice => choice.key === 'PnL Options');

  const pnlEntry = findPnlConfigEntry(pnlOptionsChoice?.values, unitLocationId, category);

  return {
    category,
    pnlOptions: pnlEntry?.values || []
  };
};

export const toPnlTableRows = toCommissionTableRows;
export const fromPnlTableRows = fromCommissionTableRows;

export const resetPnlOptionsInFormValues = (formValues, appChoices) => {
  const { pnlOptions } = getPnlConfigForInventory(
    appChoices,
    formValues.unitLocation,
    formValues.numberOfSections
  );

  return {
    ...formValues,
    pnlOptions: buildCommissionSheetTableRowsFromConfig(pnlOptions, [])
  };
};

export const buildPnlPayload = values => ({
  pnlOptions: fromPnlTableRows(values.pnlOptions)
});
